export default __webpack_public_path__ + "static/media/map.97886291.png";